module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"updateAvailable":{"buttonTitle":"Update","title":"New version of the app is available!"}},"fi":{"updateAvailable":{"buttonTitle":"Päivitä","title":"Sovelluksen uusi versio on saatavilla!"}},"sv":{"updateAvailable":{"buttonTitle":"Uppdatera","title":"En ny version av appen är tillgänglig!"}}}')
  delete Component.options._Ctor
}
